import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AmenityIconList from './AmenityIconList';

const AmenitiesListMobile = ({
    className,
    rate,
    isMonthly
}) => {
    const classes = classNames(
        'AmenitiesList',
        className
    );

    if (!rate) { return null; }

    return (
        <div className={classes}>
            <h4 className="subtitle">Amenities <small className="AmenitiesList-details">(tap for details)</small></h4>
            <AmenityIconList
                isMonthly={isMonthly}
                rate={rate}
            />
        </div>
    );
};

AmenitiesListMobile.propTypes = {
    className: PropTypes.string,
    rate: PropTypes.object,
    isMonthly: PropTypes.bool.isRequired
};

export default AmenitiesListMobile;
